// extracted by mini-css-extract-plugin
module.exports = {"MobileList":"MobileList-1hzBn","slideIn":"slideIn-1AODk"};